import React from "react";
import { useTranslation } from "react-i18next";
import "./resoucesTickets.scss";

function ResoucesTickets() {

  const { t } = useTranslation()

  return (
    <div className="container-numerous-processes">
      <div className="texts-numerous-processes">
        <h1>{t("tickets.resources.title")}</h1>
        <p>{t("tickets.resources.section_text_1")}</p>
        <p>{t("tickets.resources.section_text_2")}</p>
      </div>
    </div>
  );
}

export default ResoucesTickets;
